export default "__VITE_ASSET__DL2_LEA1__"